import { useState, useEffect } from 'react';
import { api } from '../lib/api';

interface User {
  id: number;
  display_name: string;
  email: string;
  avatar?: string;
}

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for existing session
    const token = api.getToken();
    if (token) {
      api.me()
        .then((data: unknown) => {
          setUser(data as User);
          setIsAuthenticated(true);
        })
        .catch(() => {
          api.clearToken();
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, []);

  const login = async (email: string, password: string) => {
    const response = await api.login(email, password);
    if (response.token) {
      api.setToken(response.token);
      setUser(response.player as User);
      setIsAuthenticated(true);
    }
    return response;
  };

  const register = async (displayName: string, email: string, password: string) => {
    const response = await api.register(displayName, email, password);
    if (response.token) {
      api.setToken(response.token);
      setUser(response.player as User);
      setIsAuthenticated(true);
    }
    return response;
  };

  const logout = () => {
    api.logout();
    api.clearToken();
    setUser(null);
    setIsAuthenticated(false);
  };

  return { user, isAuthenticated, isLoading, login, register, logout };
}